import { ChangeDetectionStrategy, Component, OnDestroy, inject } from '@angular/core';
// Dialog support
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { Dialog } from '../../interfaces/create-dialog.interface';
import { AutoUnsubscribe } from '../../decorators/auto-unsubscribe.decorator';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { NotebookFormComponent } from '../notebook-form/notebook-form.component';
import { ProjectFormComponent } from '../project-form/project-form.component';

@AutoUnsubscribe()
@Component({
  standalone: true,
  selector: 'app-edit-project-dialog',
  templateUrl: './edit-project-dialog.component.html',
  styleUrls: ['./edit-project-dialog.component.scss'],
  imports: [
    MatIconModule,
    MatButtonModule,
    MatDialogModule,
    ProjectFormComponent,
    NotebookFormComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditProjectDialogComponent implements OnDestroy {
  data = inject<Dialog>(MAT_DIALOG_DATA);


  // eslint-disable-next-line
  ngOnDestroy() {
    // This method is intentionally empty
  }
}
